import {ChecklistRepository} from '../repository/ChecklistRepository';
import {Checklist} from '../models/checklist.model';

export class GetChecklistByIdUseCase {
  constructor (private checklistRepository: ChecklistRepository) {}

  async execute (id: number): Promise<Checklist> {
    return this.checklistRepository.getById(id);
  }
}
